<template>
    <div id="vehicles-lists" style="z-index: -100">
      <div style="display: flex; justify-content: space-between">
        <h1>{{ $i18n.t('pages.vehicles_lists.title') }}</h1>
        <div style="display: flex; justify-content: space-around">
          <file-import :addressees="addressees" @load_data_from_parser="load_data_from_parser">
            <template v-slot:button>
              <v-btn
                  class="white--text mr-1 ml-1"
                  style="border-radius: 4px"
                  color="#DBEAF1"
                  elevation="0"
                  height="42"
              >
                <v-icon>$icon_file_download</v-icon>
                <span class="main_color button-font">{{ $i18n.t('pages.vehicles_lists.data_import.title') }}</span>
              </v-btn>
            </template>
          </file-import>
          <file-export>
            <template v-slot:button>
              <v-btn
                  class="white--text mr-1 ml-1"
                  style="border-radius: 4px"
                  color="#DBEAF1"
                  elevation="0"
                  height="42"
              >
                <v-icon>$icon_file_download</v-icon>
                <span class="main_color button-font">{{ $i18n.t('pages.vehicles_lists.data_export.title') }}</span>
              </v-btn>
            </template>
          </file-export>
        </div>
      </div>

      <v-tabs v-model="current_tab_index" style="margin-top: 15px;" background-color="transparent" @change="fetch_search_data(1, itemsPerPage)">
        <v-tab value><span class="tab-font">{{ $i18n.t('pages.vehicles_lists.whitelist') }}</span></v-tab>
        <v-tab value><span class="tab-font">{{ $i18n.t('pages.vehicles_lists.blacklist') }}</span></v-tab>
        <v-tab value><span class="tab-font">{{ $i18n.t('pages.vehicles_lists.greylist') }}</span></v-tab>

        <v-tab-item key="whitelist" class="rounded_8px">
            <v-card id="whitelist_card" class="tab_card">
              <v-card-title style="display: flex; justify-content: space-between">
                <div style="display: flex; justify-content: space-between">
                  <span class="main_card_title" style="margin-top: 0">{{ $i18n.t('pages.vehicles_lists.whitelist') }}</span>
                  <v-btn
                    v-show="selected_whitelist_cars.length"
                    class="white--text"
                    height="42"
                    color="#FFFFFF"
                    elevation="0"
                    @click="set_known_selected_cars('whitelist')"
                  >
                    <span style="color: #207EA9" class="button-font">{{ $i18n.t('pages.vehicles_lists.delete_selected') }}</span>
                  </v-btn>
                </div>
                <div>
                  <v-text-field
                    outlined
                    append-icon="mdi-magnify"
                    v-model="search"
                    :label="$i18n.t('general.search')"
                    hide-details
                    clearable
                    class="search-field rounded_8px"
                    @input="fetchEntriesDebounced"
                  />
                </div>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :loading="tables_loading"
                  :loading-text="$i18n.t('general.loading')"
                  style="letter-spacing: 0.25px;"
                  dense
                  :headers="whitelist_headers"
                  :items="whitelist_cars"
                  :items-per-page="itemsPerPage"
                  :search="whitelist_search"
                  show-select
                  item-key="inner_id"
                  v-model="selected_whitelist_cars"
                  :custom-sort="vehicles_list_sort"
                  hide-default-footer
                >
                  <template #footer.page-text="props">
                  {{ $i18n.t('table_footers.some_rows_of_all', {some: `${props.pageStart}-${props.pageStop}`, all: `${props.itemsLength}`})}}
                  </template>

                  <template v-slot:item.license_plate="{item}">
                    <v-chip outlined color="#207EA9" style="height: 24px;
                                                            box-sizing: border-box;
                                                            border-radius: 8px;
                                                            width: 105px;
                                                            display: flex; justify-content: center"
                    >
                      <span style="color: black">{{item.license_plate}}</span>
                    </v-chip>
                  </template>
                  <template v-slot:item.owner_fio="{item}">
                    {{item.owner_fio}}
                  </template>
                  <template v-slot:item.pass_type="{item}">
                    {{$i18n.t(`pages.vehicles_lists.pass_types.${item.pass_type}`)}}
                  </template>
                  <template v-slot:item.access_start_datetime="{item}">
                     {{item.access_start_datetime | json_datetime_to_readable_str(item.access_start_datetime)}}
                  </template>
                  <template v-slot:item.access_expiration_datetime="{item}">
                    {{item.access_expiration_datetime | json_datetime_to_readable_str(item.access_expiration_datetime)}}
                  </template>
                  <template v-slot:item.access_by_datetime_granted="{item}">
                    <div>
                      <span v-if="item.access_by_datetime_granted && !item.is_suspended"
                          style="height: 20px;
                                 width: 20px;
                                 background-color: #9c6;
                                 border-radius: 20px;
                                 display: inline-block;"
                      >
                      </span>
                      <span v-if="item.access_by_datetime_granted && item.is_suspended"
                          style="height: 20px;
                                 width: 20px;
                                 background-color: #9c6;
                                 border-radius: 20px;
                                 display: inline-block;"
                      >
                        <span style="
                                 display: inline-block;
                                 border-bottom: red;
                                 border-bottom-width: 3px;
                                 transform: rotate(-45deg);
                                 background-color: red;
                                 width: 20px;
                                 height: 2px;
                                 margin-bottom: 5px;
">
                        </span>
                      </span>
                      <span v-if="!item.access_by_datetime_granted"
                            style="height: 20px;
                                   width: 20px;
                                   background-color: #fa4848;
                                   border-radius: 20px;
                                   display: inline-block;"
                      >
                      </span>
                    </div>
                  </template>
                  <template v-slot:item.actions="{item}">
                    <div v-if="item.source !== 'external'" style="display: flex; justify-content: center">
                      <vehicles-list-item-editor
                          :list_name="'whitelist'"
                          :addressees="addressees"
                          :lpr_devices="lpr_devices"
                          :requests_to_server="true"
                          :car="item"
                          :car_index="whitelist_cars.indexOf(item)"
                          @edit_vehicles_lists="edit_vehicles_list"
                      >
                        <template v-slot:button>
                          <v-btn icon ><v-icon>$icon_edit</v-icon></v-btn>
                        </template>
                      </vehicles-list-item-editor>
                      <v-btn icon>
                        <v-btn icon @click="set_car_known(item)"><v-icon>$icon_trash</v-icon></v-btn>
                      </v-btn>
                    </div>
                    <div v-else style="display: flex; justify-content: center;">
                      <vehicles-list-item-editor
                          :watch_only="true"
                          :addressees="addressees"
                          :lpr_devices="lpr_devices"
                          :car="item"
                      >
                        <template v-slot:button>
                          <v-btn icon ><v-icon color="#303030">mdi-eye</v-icon></v-btn>
                        </template>
                      </vehicles-list-item-editor>
                    </div>
                  </template>
                </v-data-table>
                <div style="display: flex; justify-content: center">
                  <div style="justify-self: center;margin-left: 400px; width: 600px; margin-top: 10px">
                    <v-pagination
                        v-model="page"
                        :length=pageCount
                        :total-visible="7"
                        @input="fetch_search_data"
                        ></v-pagination>
                      </div>
                  <div style="margin-left: 400px">
                    <v-select
                      :items="rows_per_page"
                      :label="$i18n.t('table_footers.rows_per_page')"
                      @change="SetItemsPerPage"
                    ></v-select>
                  </div>
                </div>
              </v-card-text>
            </v-card>
        </v-tab-item>

        <v-tab-item key="blacklist" class="rounded_8px">
            <v-card id="blacklist_card" class="tab_card">
              <v-card-title style="display: flex; justify-content: space-between">
                  <span class="main_card_title" style="margin-top: 0">{{ $i18n.t('pages.vehicles_lists.blacklist') }}</span>
                    <v-text-field
                      outlined
                      append-icon="mdi-magnify"
                      v-model="search"
                      :label="$i18n.t('general.search')"
                      hide-details
                      clearable
                      class="search-field rounded_8px"
                      @input="fetchEntriesDebounced"
                    />
              </v-card-title>
              <v-card-text>

                <v-data-table
                  :loading="tables_loading"
                  :loading-text="$i18n.t('general.loading')"
                  :headers="blacklist_headers"
                  :items="blacklist_cars"
                  :items-per-page="itemsPerPage"
                  dense
                  hide-default-footer
                >
                  <template #footer.page-text="props">
                  {{ $i18n.t('table_footers.some_rows_of_all', {some: `${props.pageStart}-${props.pageStop}`, all: `${props.itemsLength}`})}}
                  </template>
                  <template v-slot:item.license_plate="{item}">
                     <v-chip
                         outlined color="#207EA9"
                         style="height: 24px;
                                                            box-sizing: border-box;
                                                            border-radius: 8px;
                                                            width: 105px;
                                                            display: flex; justify-content: center"
                     >
                        <span style="color: black">{{item.license_plate}}</span>
                     </v-chip>
                  </template>
                  <template v-slot:item.owner_fio="{item}">
                      {{item.owner_fio}}
                  </template>
                  <template v-slot:item.actions="{item}">
                    <div v-if="item.source !== 'external'" style="display: flex; justify-content: center">
                      <vehicles-list-item-editor
                          :list_name="'blacklist'"
                          :addressees="addressees"
                          :lpr_devices="lpr_devices"
                          :requests_to_server="true"
                          :car="item"
                          :car_index="blacklist_cars.indexOf(item)"
                          @edit_vehicles_lists="edit_vehicles_list"
                      >
                        <template v-slot:button>
                          <v-btn icon ><v-icon>$icon_edit</v-icon></v-btn>
                        </template>
                      </vehicles-list-item-editor>
                       <div style="display: flex; justify-content: flex-end">
                         <v-btn icon  @click="set_car_known(item)"><v-icon>$icon_trash</v-icon></v-btn>
                       </div>
                    </div>
                    <div v-else style="display: flex; justify-content: end">
                      <vehicles-list-item-editor
                          :watch_only="true"
                          :addressees="addressees"
                          :lpr_devices="lpr_devices"
                          :car="item"
                      >
                        <template v-slot:button>
                          <v-btn icon ><v-icon color="#303030">mdi-eye</v-icon></v-btn>
                        </template>
                      </vehicles-list-item-editor>
                    </div>
                  </template>
                </v-data-table>
                <div style="display: flex; justify-content: center">
                  <div style="justify-self: center;margin-left: 400px; width: 600px; margin-top: 10px">
                    <v-pagination
                        v-model="page"
                        :length=pageCount
                        :total-visible="7"
                        @input="fetch_search_data"
                        ></v-pagination>
                      </div>
                  <div style="margin-left: 400px">
                    <v-select
                      :items="rows_per_page"
                      :label="$i18n.t('table_footers.rows_per_page')"
                      @change="SetItemsPerPage"
                    ></v-select>
                  </div>
                </div>
              </v-card-text>
            </v-card>
        </v-tab-item>

        <v-tab-item key="greylist" class="rounded_8px">
            <v-card class="tab_card" id="greylist_card">
              <v-card-title style="display: flex; justify-content: space-between">
                <div style="display: flex; justify-content: space-between">
                  <span class="main_card_title" style="margin-top: 0">{{ $i18n.t('pages.vehicles_lists.greylist') }}</span>
                  <v-btn
                    v-show="selected_known_cars.length"
                    class="white--text"
                    height="42"
                    color="#FFFFFF"
                    elevation="0"
                    @click="delete_selected_cars('known')"
                  >
                    <span style="color: #207EA9" class="button-font">{{ $i18n.t('pages.vehicles_lists.delete_selected') }}</span>
                  </v-btn>
                </div>
                <div>
                  <v-text-field
                    outlined
                    append-icon="mdi-magnify"
                    v-model="search"
                    :label="$i18n.t('general.search')"
                    hide-details
                    clearable
                    class="search-field rounded_8px"
                    @input="fetchEntriesDebounced"
                  />
                </div>
              </v-card-title>
              <v-card-text>

                <v-data-table
                  :loading="tables_loading"
                  :loading-text="$i18n.t('general.loading')"
                  :headers="known_headers"
                  :items="known_cars"
                  :items-per-page="itemsPerPage"
                  dense
                  show-select
                  item-key="inner_id"
                  v-model="selected_known_cars"
                  hide-default-footer
                >
                  <template #footer.page-text="props">
                  {{ $i18n.t('table_footers.some_rows_of_all', {some: `${props.pageStart}-${props.pageStop}`, all: `${props.itemsLength}`})}}
                  </template>
                  <template v-slot:item.license_plate="{item}">
                     <v-chip
                         outlined color="#207EA9"
                         style="height: 24px;
                                box-sizing: border-box;
                                border-radius: 8px;
                                width: 105px;
                                display: flex; justify-content: center"
                     >
                        <span style="color: black">{{item.license_plate}}</span>
                     </v-chip>
                  </template>
                  <template v-slot:item.owner_fio="{item}">
                      {{item.owner_fio}}
                  </template>
                  <template v-slot:item.actions="{item}">
                    <div v-if="item.source !== 'external'" style="display: flex; justify-content: flex-end">
                      <vehicles-list-item-editor
                          :list_name="'known'"
                          :addressees="addressees"
                          :requests_to_server="true"
                          :car="item"
                          :car_index="known_cars.indexOf(item)"
                          @edit_vehicles_lists="edit_vehicles_list"
                      >
                        <template v-slot:button>
                          <v-btn icon ><v-icon>$icon_edit</v-icon></v-btn>
                        </template>
                      </vehicles-list-item-editor>
                       <div style="display: flex; justify-content: flex-end">
                         <v-btn icon  @click="delete_car(item)"><v-icon>$icon_trash</v-icon></v-btn>
                       </div>
                    </div>
                    <div v-else style="display: flex; justify-content: end; padding-right: 18px;">
                      <vehicles-list-item-editor
                          :watch_only="true"
                          :addressees="addressees"
                          :car="item"
                      >
                        <template v-slot:button>
                          <v-btn icon ><v-icon color="#303030">mdi-eye</v-icon></v-btn>
                        </template>
                      </vehicles-list-item-editor>
                    </div>
                  </template>
                </v-data-table>
                <div style="display: flex; justify-content: center">
                  <div style="justify-self: center;margin-left: 400px; width: 600px; margin-top: 10px">
                    <v-pagination
                        v-model="page"
                        :length=pageCount
                        :total-visible="7"
                        @input="fetch_search_data"
                        ></v-pagination>
                      </div>
                  <div style="margin-left: 400px">
                    <v-select
                      :items="rows_per_page"
                      :label="$i18n.t('table_footers.rows_per_page')"
                      @change="SetItemsPerPage"
                    ></v-select>
                  </div>
                </div>
              </v-card-text>
            </v-card>
        </v-tab-item>
      </v-tabs>

      <vehicles-list-item-editor
          :car="default_car"
          :list_name="current_tab_index === 0 ? 'whitelist' : 'blacklist'"
          @edit_vehicles_lists="edit_vehicles_list"
          :addressees="addressees"
          :lpr_devices="lpr_devices"
          :requests_to_server="true"
          class="plus-button-component-positioning"
      >
        <template v-slot:button>
          <v-btn
            class="white--text"
            elevation="0"
            fab
            height="72px"
            width="72px"
          >
            <v-icon size="72px">$icon_rounded_plus</v-icon>
          </v-btn>
        </template>
      </vehicles-list-item-editor>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import 'moment-timezone'
import VehiclesListItemEditor from '../components/VehiclesListItemEditor'
import {i18n} from "@/i18n";
import {EventBus} from "@/bus";
import FileImport from "@/components/FIleImport";
import FileExport from "@/components/FileExport";
import {date_time_converters} from "@/mixins/date_time_converters";
import {custom_table_filters} from "@/mixins/custom_table_filters";
import {custom_table_sorts} from "@/mixins/custom_table_sorts";
import {common_funcs} from "@/mixins/common";

export default {
    name: "AccessListsPage",
    components: {
      FileExport,
      FileImport,
      VehiclesListItemEditor,
    },
    mixins: [date_time_converters, custom_table_filters, custom_table_sorts, common_funcs],
    data: function () {
      EventBus.$on('ws_on_message', this.ws_on_message)

      this.fetch_addressees_data()
      this.fetch_lpr_devices_data()
      return {
        tables_loading: true,
        vehicles_lists_form_valid: '',
        validation_rules: {
          license_plate: [
            v => !!v || i18n.t('validation.this_field_is_required'),
          ],
          date_field: [
              v => !!v || i18n.t('validation.this_field_is_required'),
          ],
          start_date: [
              v => !!v || i18n.t('validation.this_field_is_required'),
          ],
          start_time: [
              v => !!v || i18n.t('validation.this_field_is_required'),
          ]
        },
        current_tab_index: null,
        add_car_dialog: false,
        dialog_type: '',
        menus: {
          start_date_menu: '',
          start_time_menu: '',
          expiration_date_menu: '',
          expiration_time_menu: '',
        },
        access_datetime: {
          start_date: '',
          expiration_date: '',
          start_time: '',
          expiration_time: '',
        },
        addressees: [],
        lpr_devices: [],

        edited_car_index: -1,
        default_car: {
          // _id: '',
          inner_id: '',
          license_plate: '',
          owner_fio: '',
          access_type: '', // blacklist or whitelist
          access_by_datetime_granted: '',
          pass_type: 'temporary', // unlimited, disposable, temporary, days_of_week

          access_days: [],
          daily_access_start_time: 0, //int, minutes from 00:00
          daily_access_finish_time: 0, //int, minutes from 00:00

          access_start_datetime: '',
          access_expiration_datetime: '',

          addressees_external_ids: [],
          lpr_devices_inner_ids: [],
          is_suspended: false,
          source: 'manual',
          status: 'active',
          entity_status: 'arrives',
          external_id: '',
        },
        selected_whitelist_cars: [],
        selected_known_cars: [],
        whitelist_headers: [
            {text: i18n.t('pages.vehicles_lists.table.headers.license_plate'), value: 'license_plate', align: 'start'},
            {text: i18n.t('pages.vehicles_lists.table.headers.owner_name'), value: 'owner_fio'},
            {text: i18n.t('pages.vehicles_lists.table.headers.pass_type'), value: 'pass_type'},
            {text: i18n.t('pages.vehicles_lists.table.headers.access_start_date'), value: 'access_start_datetime'},
            {text: i18n.t('pages.vehicles_lists.table.headers.access_expiration_date'), value: 'access_expiration_datetime'},
            {text: i18n.t('pages.vehicles_lists.table.headers.access_granted'), value: 'access_by_datetime_granted', align: 'center'},
            {text: i18n.t('pages.vehicles_lists.table.headers.actions'), value: 'actions', align: 'end', sortable: false, width: '100px'}
        ],
        blacklist_headers: [
            {text: i18n.t('pages.vehicles_lists.table.headers.license_plate'), value: 'license_plate', sortable: false, align: 'start'},
            {text: i18n.t('pages.vehicles_lists.table.headers.owner_name'), value: 'owner_fio'},
            {text: i18n.t('pages.vehicles_lists.table.headers.actions'), align: 'end', value: 'actions', sortable: false, width: '100px'}
        ],
        known_headers: [
            {text: i18n.t('pages.vehicles_lists.table.headers.license_plate'), value: 'license_plate', align: 'start'},
            {text: i18n.t('pages.vehicles_lists.table.headers.owner_name'), value: 'owner_fio'},
            {text: i18n.t('pages.vehicles_lists.table.headers.actions'), align: 'end', value: 'actions', sortable: false}
        ],
        blacklist_cars: [],
        whitelist_cars: [],
        known_cars: [],
        whitelist_search: '',
        blacklist_search: '',
        known_search: '',
        lists_translations: {
          blacklist: i18n.t('pages.vehicles_lists.blacklist'),
          whitelist: i18n.t('pages.vehicles_lists.whitelist'),
          known: i18n.t('pages.vehicles_lists.known'),
          unknown: i18n.t('pages.vehicles_lists.unknown')
        },
        page: 1,
        pageCount: 10,
        itemsPerPage: 20,
        rows_per_page: [10, 20, 30, 50, 100],
        current_list: 'whitelist',
        search: '',
      }
    },
    methods: {
      ws_on_message: function (message) {
        message = JSON.parse(message)
        let method = message.method
        let params = message.params
        if (method === 'add_car_from_external') {
          this.set_car_from_external(params)
        }
        if (method === 'edit_car_from_external') {
          this.set_car_from_external(params)
        }
        if (method === 'delete_car_from_external') {
          this.delete_car_from_external(params)
        }
        if (method === 'set_car_known_from_external') {
          this.set_car_known_from_external(params)
        }
      },

      set_car_from_external: function (params) {
        console.log('SET CAR FROM EXT')
        let car_data = params
        let all_cars_array = [...this.whitelist_cars, ...this.blacklist_cars, ...this.known_cars]
        for (let car of all_cars_array) {
          if (car.inner_id === car_data.inner_id) {
            // Если с сервера пришёл запрос на изменение пропуска, не подразумевающий изменение списка
            if (car.access_type === car_data.access_type) {
              switch (car.access_type) {
                case 'whitelist':
                  Object.assign(this.whitelist_cars[this.whitelist_cars.indexOf(car)], car_data)
                  return
                case 'blacklist':
                  Object.assign(this.blacklist_cars[this.blacklist_cars.indexOf(car)], car_data)
                  return
                default:
                  Object.assign(this.known_cars[this.known_cars.indexOf(car)], car_data)
                  return
              }
            } else {
              switch (car.access_type) {
                case 'whitelist':
                  this.whitelist_cars.splice(this.whitelist_cars.indexOf(car), 1)
                  break
                case 'blacklist':
                  this.blacklist_cars.splice(this.blacklist_cars.indexOf(car), 1)
                  break
                default:
                  this.known_cars.splice(this.known_cars.indexOf(car), 1)
                  break
              }
              switch (car_data.access_type) {
                case 'whitelist':
                  this.whitelist_cars.push(car_data)
                  return
                case 'blacklist':
                  this.blacklist_cars.push(car_data)
                  return
                default:
                  this.known_cars.push(car_data)
                  return
              }
            }
          }
        }
        if (car_data['access_type'] === 'whitelist') {
          for (let car of this.whitelist_cars) {
            if (car.inner_id === car_data.inner_id) {
              let car_index = this.whitelist_cars.indexOf(car)
              Object.assign(this.whitelist_cars[car_index], car_data)
              return
            }
          }
          this.whitelist_cars.push(car_data)
        } else if (car_data['access_type'] === 'blacklist') {
          for (let car of this.blacklist_cars) {
            if (car.inner_id === car_data.inner_id) {
              let car_index = this.blacklist_cars.indexOf(car)
              Object.assign(this.blacklist_cars[car_index], car_data)
              return
            }
          }
          this.blacklist_cars.push(car_data)
        } else {
          for (let car of this.known_cars) {
            if (car.inner_id === car_data.inner_id) {
              let car_index = this.known_cars.indexOf(car)
              Object.assign(this.known_cars[car_index], car_data)
              return
            }
          }
          this.known_cars.push(car_data)
        }
      },
      delete_car_from_external: function (params) {
        let id_type = ''
        if ('external_id' in params) {
          id_type = 'external_id'
        } else if ('inner_id' in params) {
          id_type = 'inner_id'
        }
        if (id_type === '') return
        for (let car of this.whitelist_cars) {
          if (car[id_type] === params[id_type]) {
            this.whitelist_cars.splice(this.whitelist_cars.indexOf(car), 1)
            return
          }
        }
        for (let car of this.known_cars) {
          if (car[id_type] === params[id_type]) {
            this.known_cars.splice(this.known_cars.indexOf(car), 1)
            return
          }
        }
        for (let car of this.blacklist_cars) {
          if (car[id_type] === params[id_type]) {
            this.blacklist_cars.splice(this.blacklist_cars.indexOf(car), 1)
            return
          }
        }
      },
      set_car_known_from_external: function (params) {
        console.log(`Setting car known from external: ${params}`)
        for (let car of this.whitelist_cars) {
          if (car['inner_id'] === params['inner_id']) {
            this.whitelist_cars.splice(this.whitelist_cars.indexOf(car), 1)
            let edited_car = this.make_car_known(car)
            this.known_cars.push(edited_car)
            return
          }
        }
        for (let car of this.blacklist_cars) {
          if (car['inner_id'] === params['inner_id']) {
            this.blacklist_cars.splice(this.blacklist_cars.indexOf(car), 1)
            let edited_car = this.make_car_known(car)
            this.known_cars.push(edited_car)
            return
          }
        }
      },
      fetch_data: function (page, itemsPerPage) {
        let t = this
        t.whitelist_cars = []
        t.blacklist_cars = []
        t.known_cars = []
        let current_list = this.set_new_current_list()
        this.$http({url: this.$http_hostname + '/vehicles_lists/all?pagination='+ itemsPerPage + '&page=' + page + '&list=' + current_list, method: 'GET'})
        .then( (resp) => {
          resp.data["permits"].forEach((car) => {
            if (car['access_type'] === 'whitelist') {
              t.whitelist_cars.push(car)
            } else
            if (car['access_type'] === 'blacklist') {
              t.blacklist_cars.push(car)
            } else
              t.known_cars.push(car)
          })
          this.pageCount = resp.data["page_count"]
          this.tables_loading = false
        })
        .catch(() => {
          this.setSnackbar({
            text: i18n.t('notifications.error_during_data_loading'),
          })
          this.tables_loading = false
        })
      },
      fetch_search_data: function () {
        let search = ''
        if (this.search !== null){
          search = this.normilize_license_plate(this.search)
        }
        let t = this
        t.whitelist_cars = []
        t.blacklist_cars = []
        t.known_cars = []
        let current_list = this.set_new_current_list()
        this.$http({url: this.$http_hostname + '/vehicles_lists/all?pagination='+ this.itemsPerPage + '&page=' + this.page + '&list=' + current_list + '&search=' + search, method: 'GET'})
        .then( (resp) => {
          resp.data["permits"].forEach((car) => {
            if (car['access_type'] === 'whitelist') {
              t.whitelist_cars.push(car)
            } else
            if (car['access_type'] === 'blacklist') {
              t.blacklist_cars.push(car)
            } else
              t.known_cars.push(car)
          })
          this.pageCount = resp.data["page_count"]
          this.tables_loading = false
        })
        .catch(() => {
          this.setSnackbar({
            text: i18n.t('notifications.error_during_data_loading'),
          })
          this.tables_loading = false
        })
      },
      fetch_addressees_data: function () {
        this.$http({url: this.$http_hostname + '/addressees/all', method: 'GET'})
        .then(resp => {
          this.addressees = resp.data
        })
        .catch(() => {
          this.setSnackbar({
              text: i18n.t('notifications.error_during_data_loading'),
          })
        })
      },
      fetch_lpr_devices_data: function () {
        this.$http({url: this.$http_hostname + '/lpr_devices/all', method: 'GET'})
        .then(resp => {
          this.lpr_devices = resp.data.lpr_devices
        })
        .catch(() => {
        this.setSnackbar({
            text: i18n.t('notifications.error_during_data_loading'),
        })
      })
      },
      SetItemsPerPage(count){
        this.itemsPerPage = count
        this.fetchEntriesDebounced()
      },
      set_new_current_list(){
        let current_list
        if (this.current_tab_index === 0 || this.current_tab_index === null){
          current_list = 'whitelist'
        }
        else if (this.current_tab_index === 1) {
          current_list = 'blacklist'
        }
        else if (this.current_tab_index === 2) {
          current_list = 'known'
        }
        return current_list
      },
      set_car_known: function (car) {
        if (!['whitelist', 'blacklist'].includes(car.access_type)) {
          console.log('--> Cant perform set known from current type of list')
          return
        }
        let data = {'inner_id': car.inner_id}
        confirm(i18n.t(
            'submissions.delete_plate', {plate: car.license_plate, list_name: this.lists_translations[car.access_type]}
        )) &&
        this.$http({
          url: this.$http_hostname + '/vehicles_lists/set_known_by_inner_id', data: data, method: 'DELETE'
        })
        .then(() => {
          if (car.access_type === 'blacklist') {
            this.blacklist_cars.splice(this.blacklist_cars.indexOf(car), 1)
          } else if (car.access_type === 'whitelist') {
            this.whitelist_cars.splice(this.whitelist_cars.indexOf(car), 1)
          } else if (car.access_type === 'known') {
            this.known_cars.splice(this.known_cars.indexOf(car), 1)
          }
          car = this.make_car_known(car)
          this.known_cars.push(car)
        })
        .catch(error => {
          this.show_error_message(error)
        })
      },
      delete_car: function (car) {
        if (car.access_type !== 'known') {
          console.log('--> Cant perform delete from current type of list')
          return
        }
        let data = {'inner_id': car.inner_id}
        confirm(i18n.t(
            'submissions.delete_plate', {plate: car.license_plate, list_name: this.lists_translations[car.access_type]}
        )) &&
        this.$http({
          url: this.$http_hostname + '/vehicles_lists/delete_by_inner_id', data: data, method: 'DELETE'
        })
            .then(() => {
              if (car.access_type === 'blacklist') {
                this.blacklist_cars.splice(this.blacklist_cars.indexOf(car), 1)
              }
              else if (car.access_type === 'whitelist') {
                this.whitelist_cars.splice(this.whitelist_cars.indexOf(car), 1)
              }
              else if (car.access_type === 'known') {
                this.known_cars.splice(this.known_cars.indexOf(car), 1)
              }
            })
            .catch(error => {
              this.show_error_message(error)
            })
      },
      // delete_car: function (car) {
      //   // let data = {'_id': car._id}
      //   let data = {'inner_id': car.inner_id}
      //   confirm(i18n.t('submissions.delete_plate', {plate: car.license_plate, list_name: this.lists_translations[car.access_type]})) &&
      //   this.$http({
      //     url: this.$http_hostname + '/vehicles_lists/delete_or_set_known_by_inner_id', data: data, method: 'DELETE'
      //   })
      //   .then(resp => {
      //     let op_type = resp.data.operation_type
      //     if (car.access_type === 'blacklist') {
      //       this.blacklist_cars.splice(this.blacklist_cars.indexOf(car), 1)
      //     }
      //     else if (car.access_type === 'whitelist') {
      //       this.whitelist_cars.splice(this.whitelist_cars.indexOf(car), 1)
      //     }
      //     else if (car.access_type === 'known') {
      //       this.known_cars.splice(this.known_cars.indexOf(car), 1)
      //     }
      //     if (op_type === 'set_known') {
      //       car = this.make_car_known(car)
      //       this.known_cars.push(car)
      //     }
      //   })
      //   .catch(error => {
      //     this.show_error_message(error)
      //   })
      // },
      set_known_selected_cars: function (list_name) {
        if (!['whitelist'].includes(list_name)) {
          console.log('--> Cant perform set_known_selected_cars from current type of list')
          return
        }
        if (!confirm(i18n.t('submissions.delete_selected_plates', {list_name: this.lists_translations[list_name]}))) return
        let inner_ids_array = []
        if (list_name === 'whitelist') inner_ids_array = this.get_ids_array(this.selected_whitelist_cars)
        let data = {'inner_ids': inner_ids_array}
        this.updateLoadingOverlay({is_loading: true})
        this.$http({url: this.$http_hostname + '/vehicles_lists/set_known_many_by_inner_ids', data: data, method: 'DELETE'})
        .then(resp => {
          if (resp.data.result === 'ok') {
            if (list_name === 'whitelist') {
              while (this.selected_whitelist_cars.length) {
                this.whitelist_cars.splice(this.whitelist_cars.indexOf(this.selected_whitelist_cars.pop()), 1)
              }
              this.selected_whitelist_cars = []
            }
          }
          this.updateLoadingOverlay({is_loading: false})
        })
        .catch(error => {
          this.show_error_message(error)
        })
      },
      delete_selected_cars: function (list_name) {
        if (list_name !== 'known') {
          console.log('--> Cant perform delete_selected_cars from current type of list')
          return
        }
        if (!confirm(i18n.t('submissions.delete_selected_plates', {list_name: this.lists_translations[list_name]}))) return
        let inner_ids_array = []
        inner_ids_array = this.get_ids_array(this.selected_known_cars)
        let data = {'inner_ids': inner_ids_array}
        this.updateLoadingOverlay({is_loading: true})
        this.$http({url: this.$http_hostname + '/vehicles_lists/delete_many_by_inner_ids', data: data, method: 'DELETE'})
        .then(resp => {
          if (resp.data.result === 'ok') {
            if (list_name === 'known') {
              while (this.selected_known_cars.length) {
                this.known_cars.splice(this.known_cars.indexOf(this.selected_known_cars.pop()), 1)
              }
              this.selected_known_cars = []
            }
          }
          this.updateLoadingOverlay({is_loading: false})
        })
        .catch(error => {
          this.show_error_message(error)
        })
      },

      // delete_selected_cars: function (list_name) {
      //   if (!confirm(i18n.t('submissions.delete_selected_plates', {list_name: this.lists_translations[list_name]}))) return
      //   let inner_ids_array = []
      //   if (list_name === 'whitelist') inner_ids_array = this.get_ids_array(this.selected_whitelist_cars)
      //   else if (list_name === 'known') inner_ids_array = this.get_ids_array(this.selected_known_cars)
      //   // let data = {'_ids': ids_array}
      //   let data = {'inner_ids': inner_ids_array}
      //   console.log(data)
      //   this.updateLoadingOverlay({is_loading: true})
      //   this.$http({url: this.$http_hostname + '/vehicles_lists/delete_or_set_known_many', data: data, method: 'DELETE'})
      //   .then(resp => {
      //     if (resp.data.result === 'ok') {
      //       if (list_name === 'whitelist') {
      //         while (this.selected_whitelist_cars.length) {
      //           this.whitelist_cars.splice(this.whitelist_cars.indexOf(this.selected_whitelist_cars.pop()), 1)
      //         }
      //         this.selected_whitelist_cars = []
      //       } else if (list_name === 'known') {
      //         while (this.selected_known_cars.length) {
      //           this.known_cars.splice(this.known_cars.indexOf(this.selected_known_cars.pop()), 1)
      //         }
      //         this.selected_known_cars = []
      //       }
      //     }
      //     this.updateLoadingOverlay({is_loading: false})
      //   })
      //   .catch(error => {
      //     this.show_error_message(error)
      //   })
      // },
      get_ids_array: function (cars_array) {
        let ids_array = []
        cars_array.forEach(car => {
          ids_array.push(car['inner_id'])
        })
        return ids_array
      },
      picker_date_to_slash_date: function (date_from_picker) {
        if (!date_from_picker) return null
        const [year, month, day] = date_from_picker.split('-')
        return `${day}/${month}/${year}`
      },
      // TODO TEST!
      edit_vehicles_list: function (params) {
        if (params.car_index > -1) {
        //  Car was edited
          let old_list = params.old_list
          let new_list = params.car.access_type
          if (new_list === 'whitelist') {
            if (params.old_list !== params.car.access_type) {
              if (old_list === 'blacklist') this.blacklist_cars.splice(params.car_index, 1)
              else if (old_list === 'known') this.known_cars.splice(params.car_index, 1)
              this.whitelist_cars.push(params.car)
            } else {
              Object.assign(this.whitelist_cars[params.car_index], params.car)
            }
          } else if (new_list === 'blacklist') {
            if (params.old_list !== params.car.access_type) {
              if (old_list === 'whitelist') this.whitelist_cars.splice(params.car_index, 1)
              else if (old_list === 'known') this.known_cars.splice(params.car_index, 1)
              this.blacklist_cars.push(params.car)
            } else {
              Object.assign(this.blacklist_cars[params.car_index], params.car)
            }
          } else if (new_list === 'known') {
            if (params.old_list !== params.car.access_type) {
              console.log("Warning: Trying to EDIT permit with status 'known' (!)")
            }
            else {
              Object.assign(this.known_cars[params.car_index], params.car)
            }
          }
        } else {
        //  Car was created
          if (params.car.access_type === 'whitelist') {
            this.whitelist_cars.push(params.car)
          }
          if (params.car.access_type === 'blacklist') {
            this.blacklist_cars.push(params.car)
          }
          if (params.car.access_type === 'known') {
            console.log("Warning: Trying to CREATE permit with status 'known' (!)")
          }
        }
      },
      all_select_checkbox_click: function () {
        this.setSnackbar({
          text: 'Clicked SELECT ALL'
        })
      },
      load_data_from_parser: function (params) {
        let new_data = params.new_data
        new_data.forEach((car, car_index, new_data) => {
          if (new_data[car_index].access_type === 'whitelist') {
            this.whitelist_cars.push(new_data[car_index])
          } else if (new_data[car_index].access_type === 'blacklist') {
            this.blacklist_cars.push(new_data[car_index])
          }
        })
        this.setSnackbar({
          text: i18n.t('notifications.vehicles_lists.data_imported_successfully')
        })
      },
      change_car_selected_status: function (car) {
        if (this.selected_whitelist_cars.includes(car)) {
          this.selected_whitelist_cars.splice(car, 1)
        } else {
          this.selected_whitelist_cars.push(car)
        }
      },
      make_car_known: function (car) {
        car['access_type'] = 'known'
        car['access_start_datetime'] = null
        car['access_expiration_datetime'] = null
        car['pass_type'] = null
        car['access_by_datetime_granted'] = false
        return car
      },
      fetchEntriesDebounced() {
        // cancel pending call
        clearTimeout(this._timerId)
        this.page = 1
        // delay new call 500ms
        this._timerId = setTimeout(() => {
          this.fetch_search_data()
        }, 500)
      },
      ...mapActions(['setSnackbar', 'updateLoadingOverlay'])
    },

  computed: {
    formatted_start_date: function () {
      return this.picker_date_to_slash_date(this.access_datetime.start_date)
    },
    formatted_expiration_date: function () {
      return this.picker_date_to_slash_date(this.access_datetime.expiration_date)
    },
    all_addressees_external_ids_array: function () {
      let addressees_external_ids_array = []
      this.addressees.forEach(item => {
        addressees_external_ids_array.push(item['external_id'])
      })
      return addressees_external_ids_array
    },
    ...mapGetters(['loadingOverlay'])
  },
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Open+Sans&display=swap');
.search-field {
    max-width: 18vw;
    background: #FFFFFF;
}
.v-window {
  border-radius: 8px;
}
.v-tabs-bar {
  margin-bottom: 30px;
}
.tab-font {
  font-family: Open Sans,serif;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 149.8%;
  color: #2D2B3D;
  text-transform: none;
  letter-spacing: 0.05rem;
}
</style>